import { Box } from '@mui/material';
import { Warning } from '@mui/icons-material';
import React from 'react';


export type ICSConflictsButtonProps = {
  count: number;
};


export const ICSConflictsButton: React.VFC<ICSConflictsButtonProps> = ({ count }) => {
  return (
    <Box display="flex" alignItems="center">
      <Box mr={1} display="flex" color="warning.main">
        <Warning color="inherit" />
      </Box>
      <span>Resolve {count} {count === 1 ? 'conflict' : 'conflicts'}</span>
    </Box>
  );
};
